import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { InputChanged, SelectionListBaseComponent } from '../selection-list-base/selection-list-base.component';
import { CustomerOrganizationBaseModel } from '../../../models/customer-organization-base.model';
import { FilterBase } from '../../../filters/filter-base';
import { PageConfiguration } from '../../../models/page-configuration.model';
import { Constants } from '../../../constants/constants';
import { CRMService } from '../../../services/crm.service';
import { debounceTime } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-customer-organization-selection-list',
  templateUrl: './customer-organization-selection-list.component.html',
  styleUrls: ['./customer-organization-selection-list.component.scss']
})
export class CustomerOrganizationSelectionListComponent
  extends SelectionListBaseComponent<CustomerOrganizationBaseModel>
  implements OnInit, OnChanges, OnDestroy {

  @Input() selectedObjectId: string;

  private readonly pageConfiguration = new PageConfiguration(
    Constants.CustomerOrganizations_List_DefaultSortField,
    Constants.CustomerOrganizations_List_DefaultSortDirectionAscending
  );

  private readonly filter: FilterBase = new FilterBase();
  private searchChangedSubscription: Subscription;

  constructor(private crmService: CRMService) {
    super();
  }

  ngOnInit(): void {
    // Debounced search input
    this.searchChangedSubscription = this.searchChangedEvent
      .pipe(debounceTime(500))
      .subscribe((event: InputChanged<CustomerOrganizationBaseModel>) => {
        this.filter.Name = event.term;
        this.loadSelectionList();
      });

    if (this.selectedObjectId) {
      this.prefillSelectedObject(this.selectedObjectId);
    } else {
      this.loadSelectionList();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedObjectId && !changes.selectedObjectId.firstChange) {
      this.prefillSelectedObject(changes.selectedObjectId.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.searchChangedSubscription.unsubscribe();
  }

  private prefillSelectedObject(id: string): void {
    if (!id || id === '') {
      return;
    }
    this.crmService.getOrganizationById(id).subscribe(fullObject => {
      this.selectionListSubject$.next([fullObject]);
      this.loadSelectionList(fullObject);
    });
  }

  protected loadSelectionList(prefill?: CustomerOrganizationBaseModel): void {
    this.crmService.getOrganizations(this.pageConfiguration, this.filter).subscribe(results => {
      if (prefill) {
        const filtered = results.filter(x => x.Id !== prefill.Id);
        this.selectionListSubject$.next([prefill, ...filtered]);
      } else {
        this.selectionListSubject$.next(results);
      }
    });
  }
}

